import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-strategy',
  templateUrl: './strategy.component.html',
  styleUrls: ['./strategy.component.css'],
})
export class StrategyComponent implements OnInit {
  strategyForm: FormGroup;
  loading: boolean = false;
  url: string = 'strategy';

  resumenCards = [
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/marketing',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/marketing/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/marketing/social/strategy',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'GEO',
      route: '',
    },
    
  ];

  // Filters
  filters = {
    status: '',
    purpose: '',
    vertical: '',
    requested_by_type: '',
    platform: 'instagram',
  };

  platforms = [
    {
      code: 'IG',
      value: 'instagram',
      label: 'Instagram',
      icon: 'fab fa-instagram',
      class: 'ig',
    },
    {
      code: 'FB',
      value: 'facebook',
      label: 'Facebook',
      icon: 'fab fa-facebook-f',
      class: 'fb',
    },
    {
      code: 'YT',
      value: 'youtube',
      label: 'YouTube',
      icon: 'fab fa-youtube',
      class: 'yt',
    },
    {
      code: 'TT',
      value: 'tiktok',
      label: 'TikTok',
      icon: 'fab fa-tiktok',
      class: 'tt',
    },
  ];

  get selectedPlatformInfo() {
    const platformValue =
      this.strategyForm?.get('platform')?.value || this.filters.platform;
    return (
      this.platforms.find((p) => p.value === platformValue) || this.platforms[0]
    );
  }

  surfaces_platforms = [
    {
      platform: 'instagram',
      surfaces: [
        { code: 'FD', value: 'feed_posts', label: 'Feed Posts' },
        { code: 'CR', value: 'carousels', label: 'Carousels' },
        { code: 'RL', value: 'reel', label: 'Reel' },
        { code: 'ST', value: 'story', label: 'Story' },
      ],
    },
    {
      platform: 'facebook',
      surfaces: [
        { code: 'FD', value: 'feed_posts', label: 'Feed Posts' },
        { code: 'RL', value: 'reel', label: 'Reel' },
        { code: 'ST', value: 'story', label: 'Story' },
      ],
    },
    {
      platform: 'youtube',
      surfaces: [
        { code: 'VD', value: 'video', label: 'Video' },
        { code: 'SH', value: 'short', label: 'Short' },
        { code: 'LV', value: 'live', label: 'Live' },
      ],
    },
    {
      platform: 'tiktok',
      surfaces: [
        { code: 'VD', value: 'video', label: 'Video' },
        { code: 'PH', value: 'photo_post', label: 'Photo Post' },
        { code: 'ST', value: 'story', label: 'Story' },
      ],
    },
  ];

  universes = ['Courier', 'Runner'];

  objectives = [
    'Brand Authority',
    'Service Awareness',
    'Education',
    'Consideration',
    'Engagement',
    'Conversion Support',
  ];

  categoriesByUniverse: { [key: string]: string[] } = {
    Courier: [
      'Same-Day Courier',
      'Rush & Express Courier',
      'Prime VIP Delivery',
      'Pre-Scheduled Delivery',
      'Legal Courier Services',
      'Last-Mile Delivery',
      'Concierge Courier Services',
      'Long-Distance Courier',
    ],
    Runner: ['Task Runner Services', 'Concierge Runner', 'Business Runner'],
  };

  platformSchedules: { [key: string]: { dayOfWeek: number; time: string } } = {
    instagram: { dayOfWeek: 2, time: '14:00' }, // 2 = Martes
    facebook: { dayOfWeek: 3, time: '10:00' }, // 3 = Miércoles
    youtube: { dayOfWeek: 4, time: '16:00' }, // 4 = Jueves
    tiktok: { dayOfWeek: 5, time: '18:00' }, // 5 = Viernes
  };

  get getCategories() {
    const universe = this.strategyForm.get('universe')?.value;
    return universe ? this.categoriesByUniverse[universe] || [] : [];
  }

  constructor(
    private fb: FormBuilder,
    private dataService: DataService,
    private messageService: MessageService,
  ) {
    this.strategyForm = this.fb.group({
      id: [{ value: '', disabled: true }],
      platform: ['instagram'],
      surface: ['reel'],
      postingDate: [{ value: '2026-08-18', disabled: true }],
      postingTime: [{ value: '14:00', disabled: true }],
      universe: [{ value: 'Courier', disabled: true }],
      objective: ['Brand Authority'],
      category: [{ value: 'Governed by INITIATOR', disabled: true }],
      source: [{ value: 'Social Media Organics', disabled: true }],
      focusNotes: [''],
      semantikaInstructions: [
        { value: 'Generated in MediaRoom Request Intake', disabled: true },
      ],
      idProvisional: [{ value: '', disabled: true }],
    });
  }

  ngOnInit(): void {
    this.strategyForm.get('universe')?.valueChanges.subscribe((universe) => {
      const categories = this.categoriesByUniverse[universe] || [];
      const currentCategory = this.strategyForm.get('category')?.value;
      if (!categories.includes(currentCategory)) {
        this.strategyForm.get('category')?.setValue(categories[0] || '');
      }
    });

    this.strategyForm.get('platform')?.valueChanges.subscribe((platform) => {
      this.updateScheduleForPlatform(platform);
      this.refreshId();
    });

    this.strategyForm.get('surface')?.valueChanges.subscribe(() => {
      this.refreshId();
    });

    // Inicializar el horario para la plataforma por defecto
    const initialPlatform = this.strategyForm.get('platform')?.value;
    if (initialPlatform) {
      this.updateScheduleForPlatform(initialPlatform);
    }
    this.refreshId();
  }

  generateStrategyId(platformValue: string, surfaceValue: string): string {
    const platform = this.platforms.find((p) => p.value === platformValue);
    const platformCode = platform?.code ?? 'XX';

    const allSurfaces = this.surfaces_platforms.flatMap((sp) => sp.surfaces);
    const surface = allSurfaces.find((s) => s.value === surfaceValue);
    const surfaceCode = surface?.code ?? 'XX';

    // const now = new Date();
    // const yy = String(now.getFullYear()).slice(-2);
    // const mm = String(now.getMonth() + 1).padStart(2, '0');
    // const dd = String(now.getDate()).padStart(2, '0');
    // const hh = String(now.getHours()).padStart(2, '0');
    // const min = String(now.getMinutes()).padStart(2, '0');
    // const ss = String(now.getSeconds()).padStart(2, '0');
    // const timestamp = `${yy}${mm}${dd}${hh}${min}${ss}`;
    const timestamp = String(Date.now()).slice(-4);

    return `ORG-${platformCode}-${surfaceCode}-${timestamp}`;
  }

  refreshId(): void {
    const platform = this.strategyForm.get('platform')?.value;
    const surface = this.strategyForm.get('surface')?.value;
    const newId = this.generateStrategyId(platform, surface);
    this.strategyForm
      .get('idProvisional')
      ?.setValue(newId, { emitEvent: false });
  }

  updateScheduleForPlatform(platform: string) {
    const platformKey = platform.toLowerCase();
    const schedule = this.platformSchedules[platformKey];

    if (schedule) {
      const now = new Date();
      let targetDate = new Date(now);

      const currentDay = now.getDay();
      const targetDay = schedule.dayOfWeek;
      let daysToAdd = (targetDay - currentDay + 7) % 7;

      // Si es hoy, pero la hora ya pasó, pasarlo a la próxima semana
      if (daysToAdd === 0) {
        const [targetHour, targetMinute] = schedule.time.split(':').map(Number);
        if (
          now.getHours() > targetHour ||
          (now.getHours() === targetHour && now.getMinutes() >= targetMinute)
        ) {
          daysToAdd = 7;
        }
      }

      // Si por alguna razón agregamos 0 días, es hoy mismo en un tiempo futuro
      if (daysToAdd > 0) {
        targetDate.setDate(now.getDate() + daysToAdd);
      }

      const year = targetDate.getFullYear();
      const month = String(targetDate.getMonth() + 1).padStart(2, '0');
      const day = String(targetDate.getDate()).padStart(2, '0');

      this.strategyForm.patchValue({
        postingDate: `${year}-${month}-${day}`,
        postingTime: schedule.time,
      });
    }

    const surfaces = this.getSurfacesByPlatform();
    const currentSurface = this.strategyForm.get('surface')?.value;
    const surfaceExists = surfaces.some((s) => s.value === currentSurface);
    if (!surfaceExists) {
      this.strategyForm
        .get('surface')
        ?.setValue(surfaces.length > 0 ? surfaces[0].value : '');
    }
  }

  setPlatform(platform: string): void {
    this.filters.platform = this.filters.platform === platform ? '' : platform;
  }

  getSurfacesByPlatform() {
    const selectedPlatform = this.strategyForm
      .get('platform')
      ?.value?.toLowerCase();
    const platformData = this.surfaces_platforms.find(
      (p) => p.platform === selectedPlatform,
    );
    return platformData ? platformData.surfaces : [];
  }

  onSubmit() {
    if (this.strategyForm.valid) {
      console.log('Initiative submitted:', this.strategyForm.getRawValue());
      this.messageService.add('Initiative submitted successfully', 'info');
    }
  }
}
